<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f011-02.jpg" width="80%"/></p>
<p class="caption"><em class="italic">The location of German cemeteries is usually indicated with a black and white signboard</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 13_fm028.vue?9b9c8af8